import { TrendingUpRounded } from "@material-ui/icons";
import Async from "../../components/Async";
import loginService from "../../domain/services/login.service";

const AuthGuard = Async(() => import('../auth.guard'));

// Whitelist de beta testers do Panorama IA.
// Enquanto o dashboard estiver em validação, o menu só aparece para
// estes usuários (além de exigir role growth_report para o handshake).
// Para liberar geral: remover o validator ou apagar a whitelist.
const PANORAMA_IA_BETA_EMAILS = [
    'josivan.amorim@facilitajuridico.com',
];

const isPanoramaIaBeta = () => {
    const user = loginService.getUserAuthentication();
    if (!user || !user.email) return false;
    return PANORAMA_IA_BETA_EMAILS.includes(user.email.toLowerCase());
};

const routes = {
    aiDashboardPanorama: {
        id: 'aiDashboard',
        name: 'IA Dashboard',
        icon: <TrendingUpRounded />,
        path: 'https://panorama.facilitajuridico.com',
        roles: ['growth_report'],
        validator: isPanoramaIaBeta,
        isLink: true,
        isHandshake: true,
        handshakeService: 'admin/dashboard-token',
        handshakeTargetUrl: 'https://panorama.facilitajuridico.com/auth/callback',
        guard: AuthGuard,
    },
}

const pages = Object.values(routes);

export default {
    routes,
    pages
}
